import { useState, useEffect } from 'react';
import { getAvailabilities, clearAvailabilityCache } from '@/service/bookingService';
import type { AvailabilityDocument } from '@/service/bookingService';

export const useAvailabilities = () => {
  const [availabilities, setAvailabilities] = useState<AvailabilityDocument[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchAvailabilities = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getAvailabilities();
      setAvailabilities(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch availabilities'));
    } finally {
      setIsLoading(false);
    }
  };

  const refreshAvailabilities = async () => {
    clearAvailabilityCache();
    await fetchAvailabilities();
  };

  useEffect(() => {
    fetchAvailabilities();
  }, []);

  return {
    availabilities,
    isLoading,
    error,
    refreshAvailabilities
  };
}; 